import { render } from "./CheckoutPromoTotal.vue?vue&type=template&id=0194eda7"
import script from "./CheckoutPromoTotal.vue?vue&type=script&lang=js"
export * from "./CheckoutPromoTotal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__